module.exports = __webpack_public_path__ + "img/Dior.7627eb93.png";